<!-- Modal -->
<div class="modal fade" [id]="id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="modalLabel">{{header}}</div>
        <button type="button" class="close" aria-label="Close" (click)="proceedCancel()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>EMS – Electronic Metered Standpipes.  South East Water has 14 EMS sites located throughout their area. These standpipes are activated by an key and designed for larger tankers.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="proceedYes()">Close</button>
      </div>
    </div>
  </div>
</div>
